import React from 'react'

type Props = { children: Array<React.ReactNode> }
const TagGroup: React.FC<Props> = ({ children }) => {
  return (
    <div className='flex flex-wrap gap-x-2'>
      {children}
    </div>
  )
}

export default TagGroup
